module.exports = __webpack_public_path__ + "img/65ne.6806b2d9.svg";